import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { handlers } from '../../helpers/helpers';
import statusDictionary from '../../helpers/statusDictionary.json';
import { patientsService } from "../../services/patient";
import { message } from 'antd';

const useSummaryHandler = ({ countryCode }) => {
  const navigate = useNavigate();
  const [isSummaryStarted, setIsSummaryStarted] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [isFinish, setIsFinish] = useState(false);
  const [hasMoreSurveys, setHasMoreSurveys] = useState(false);
  const [surveys, setSurveys] = useState();
  const [currentSurvey, setCurrentSurvey] = useState();
  const [currentSurveyIndex, setCurrentSurveyIndex] = useState(0);
  const [error, setError] = useState();
  const [questionToEdit, setQuestionToEdit] = useState();

  useEffect(() => {
    if (surveys) {
      setCurrentSurvey(surveys.find(survey => survey.current));
      setCurrentSurveyIndex(surveys.findIndex(survey => survey.current));
      handlers.handleSurveyData({
        ...JSON.parse(localStorage.getItem('surveyData')),
        surveys
      });
    }
  }, [surveys])

  useEffect(() => {
    if (questionToEdit) {
      localStorage.setItem('questionToEdit', JSON.stringify(questionToEdit));
      navigate(`/mis-examenes/${countryCode}/encuesta-salud`);
    }
  }, [countryCode, navigate, questionToEdit])

  useEffect(() => {
    if (isSummaryStarted !== undefined) {
      handlers.handleSurveyData({
        ...JSON.parse(localStorage.getItem('surveyData')),
        is_summary_started: isSummaryStarted
      });
    }
  }, [isSummaryStarted])

  const saveResults = useCallback(async () => {
    setLoading(true);
    try {
      const surveyData = JSON.parse(localStorage.getItem('surveyData'));
      surveyData.surveys = surveys;
      surveyData.exam_code = surveyData.exam_code;
      delete surveyData.is_finish;
      delete surveyData.is_summary_started;

      const saveSurveysResponse = await patientsService.savePatientSurvey(surveyData)

      if (saveSurveysResponse) {
        const setAdmissionPatientExamStateResponse = await patientsService.setAdmissionPatientExamState({
          admission_patient_exam_id: surveyData.admission_patient_exam_id,
          exam_code: surveyData.exam_code,
          state: statusDictionary.done.status,
        })

        if (setAdmissionPatientExamStateResponse) {
          localStorage.removeItem('surveyData');
          const userData = JSON.parse(localStorage.getItem('userData'));
          let moreSurveys = false;
          if (userData) {
            if (userData.exams) {
              moreSurveys = userData.exams.some((exam) => {
                const isCurrentExam = exam.admission_patient_exam_id === surveyData.admission_patient_exam_id;
                return !isCurrentExam && exam.has_survey && exam.state !== statusDictionary.done.status;
              });
            }
            userData.tabs = false;
            localStorage.setItem('userData', JSON.stringify(userData));
          }
          setHasMoreSurveys(moreSurveys);
          setIsFinish(true);
        }
      }
    } catch (error) {
      message.error('Ocurrió un error al guardar los resultados de la encuesta');
    } finally {
      setLoading(false);
    }
  }, [surveys])

  const nextSurvey = useCallback(() => {
    if (currentSurveyIndex + 1 >= surveys.length) {
      saveResults()
    } else {
      const newSurveys = surveys.map((survey, index) => {
        if (index === currentSurveyIndex + 1) {
          return {
            ...survey,
            current: true
          }
        } else {
          return {
            ...survey,
            current: false
          }
        }
      });
      setSurveys(newSurveys);
      window.scrollTo(0, 0, { behavior: 'smooth' });
    }
  }, [currentSurveyIndex, saveResults, surveys])

  const prevSurvey = useCallback(() => {
    setLoading(true);
    const newSurveys = surveys.map((survey, index) => {
      if (index === currentSurveyIndex - 1) {
        return {
          ...survey,
          current: true
        }
      } else {
        return {
          ...survey,
          current: false
        }
      }
    });
    setSurveys(newSurveys);
    setLoading(false);
    window.scrollTo(0, 0, { behavior: 'smooth' });
  }, [currentSurveyIndex, surveys]);

  useEffect(() => {
    setSurveys();
    setQuestionToEdit();
    setError();

    const surveyData = JSON.parse(localStorage.getItem('surveyData'));

    if (surveyData) {
      if (!surveyData.is_finish) {
        navigate(`/mis-examenes/${countryCode}/encuesta-salud`);
      }

      if (surveyData.is_summary_started) {
        setIsSummaryStarted(true);
      }

      if (surveyData.surveys) {
        setSurveys(surveyData.surveys.map((survey, index) => {
          if (index === 0) {
            return {
              ...survey,
              current: true
            }
          } else {
            return {
              ...survey,
              current: false
            }
          }
        }));
      }

    } else {
      navigate(`/mis-examenes/${countryCode}`);
    }
  }, [countryCode, navigate])

  return {
    isSummaryStarted,
    setIsSummaryStarted,
    surveys,
    setQuestionToEdit,
    isFinish,
    hasMoreSurveys,
    currentSurvey,
    loading,
    currentSurveyIndex,
    nextSurvey,
    prevSurvey,
    examName: JSON.parse(localStorage.getItem('surveyData'))?.exam_name,
  };
}

export default useSummaryHandler;
